
"use strict";

angular.module('rmPresenter')

.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('presenters', {
            url: "/presenters",

            views: {

                'presentersoverview': { 
                    templateUrl: '/partial/app.partials.presenter.overview',
                    controller: 'PresenterOverviewCtrl',
                    controllerAs: 'presenterCtrl'
                },
                'presentersdetail': { 
                 
                    templateUrl: '/partial/app.panels.empty'
                }
            },

            onEnter: ['bladesManager', function( bladesManager ) {

                bladesManager.clearAll();
                bladesManager.insert({ viewName:'presentersoverview', size:'half' });
                bladesManager.insert({ viewName:'presentersdetail', size:'half' });  
            }],

            resolve: {

                itemFilters: ['$http', function( $http ) {

                    return $http.get('/usersettings').then((req) => {

                        return req.data.item_filter;
                    });
                }],

                filterMap: ['$http', function( $http ) {

                    return $http.get('/userfilters/presenter').then((req) => {

                        return req.data;
                    });
                }]
            }

        }).state('presenters.create', {
            url: "/create", 
            views: {
                
                'presentersdetail@': { 

                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'presenterCtrl'
                }
            }
        }).state('presenters.update', {
            url: "/update/:id", 
            views: {
                
                'presentersdetail@': { 

                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'presenterCtrl'
                }
            }
        });
}]);



/*
"use strict";

var app = angular.module('rmPresenter');

app.config(function ($stateProvider) {

	$stateProvider
		.state('presenter', {
			url: "/presenter",
			templateUrl: '/partial/app.partials.presenter.overview',
			controller: 'PresenterOverviewCtrl',
			controllerAs: 'presenterCtrl'

		})
		.state('presenter.create', {
			url: "/create",
            views: {
                detail: {
                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
		})
		.state('presenter.update', {
			url: "/update/:id",
            views: {
                detail: {
                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
		});
});
*/